module.exports = __webpack_public_path__ + "static/media/diary_song_bg.fc865600.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/diary/diary_song_bg.png
// module id = 126
// module chunks = 150